import { BLACKOUT_CATEGORY } from '../../checklistCategories';
import { formatContextDate } from '../../shared/format';
import type { ApprovalQueueItem } from '../../types';

import type { BlackoutChecklistRow, BlackoutCoverageSummary } from './types';

export function buildBlackoutQueueItem(
  row: BlackoutChecklistRow,
  coverage: BlackoutCoverageSummary,
): ApprovalQueueItem {
  if (row.field === 'Blackout Coverage') {
    return {
      categoryId: BLACKOUT_CATEGORY.id,
      categoryLabel: BLACKOUT_CATEGORY.label,
      description: `Cumulative blackout dates cover ${coverage.percent}% of the travel period.`,
      details: [
        { label: 'Total blackout days', value: `${coverage.blackoutDays} days (${coverage.percent}%)` },
        { label: 'Travel days', value: coverage.travelDays ? String(coverage.travelDays) : 'N/A' },
      ],
      id: row.id,
      title: row.name,
    };
  }

  return {
    categoryId: BLACKOUT_CATEGORY.id,
    categoryLabel: BLACKOUT_CATEGORY.label,
    description: `${row.name} blackout dates require approval.`,
    details: [
      { label: 'From', value: formatContextDate(row.from) },
      { label: 'To', value: formatContextDate(row.to) },
      { label: 'Within travel validity', value: row.withinTravelValidity ? 'Yes' : 'No' },
      { label: 'Clash with gala / festive dates', value: row.festiveClear ? 'No' : 'Yes' },
      { label: 'Total blackout coverage', value: `${coverage.blackoutDays} days (${coverage.percent}%)` },
    ],
    id: row.id,
    title: row.name,
  };
}

export function getBlackoutSearchText(row: BlackoutChecklistRow) {
  return [row.name, row.field, row.statusLabel, row.from, row.to].filter(Boolean).join(' ');
}
